
import  React  from 'react';
import Routers from '../../routers/Routers';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
// import Header from '../Header/Header';
// import Footer from '../Footer/Footer';

function  Layout  (props) {
    return (
        <>
            <Header />
            <Routers />
            <Footer />
        </>
    );

}

export default  Layout;

